<footer class="footer-modern">
  <div class="footer-container">

    <!-- Logo Row -->
    <div class="footer-top-row">
      <img src="../../../assets/NEXGEN Logo final.png" alt="App Logo" class="footer-logo" />
    </div>

    <!-- 3 Column Row -->
    <div class="footer-bottom-row row">

      <!-- Column 1: About -->
      <div class="footer-about col-md-4">
        <p class="footer-desc">
          Our flexible, high-impact programs—taught by NexGen Executive Coaching Academy Certified Instructors—provide the skills, mentorship, and certification needed to launch or elevate your coaching career.
        </p>

        <ul class="contact-info">
          <li><i class="fa-solid fa-phone"></i> (316) 555-0116</li>
          <li><i class="fa-solid fa-envelope"></i> contact@nexgencoaches.com</li>
          <li><i class="fa-solid fa-location-dot"></i> 4517 Washington Ave., Manchester, Kentucky 39495</li>
        </ul>

        <div class="footer-social">
          <a href="#"><i class="fa-brands fa-linkedin"></i></a>
          <a href="#"><i class="fa-brands fa-instagram"></i></a>
          <a href="#"><i class="fa-brands fa-facebook"></i></a>
          <a href="#"><i class="fa-brands fa-x-twitter"></i></a>
        </div>

        <button class="back-to-top" (click)="scrollToTop()">
          <i class="fa-solid fa-arrow-up"></i>&nbsp; Back to Top
        </button>
      </div>

      <!-- Column 2: Our Company -->
        <div class="footer-links col-md-4">
        <h4>Our Company</h4>
        <a routerLink="/about-us">About</a>
        <a routerLink="/terms-and-conditions">Terms & Conditions</a>
      </div>

      <!-- Column 3: Instructors -->
      <div class="footer-links col-md-4">
        <h4>
          <a routerLink="/our-team" style="text-decoration: none;">Our Team </a>
        </h4>
        <a (click)="goToFaq()" style="cursor: pointer;">Common FAQs</a>
        <a routerLink="/blogs">Blogs</a>
      </div>

    </div>
  </div>

  <!-- Bottom Bar -->
  <div class="footer-bottom">
    <p>© 2025 NexGen Executive Coaching Academy. All Rights Reserved.</p>
  </div>
</footer>
